import { Box, Button, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import type { ProcessingStep } from './types';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    processingSteps: ProcessingStep[];
    isActionInProgress: boolean;
    classes?: any;
}

const ConfirmMarkDoneDialog = ({ open, onClose, onConfirm, processingSteps, isActionInProgress, classes }: Props) => {
    const inProgressName = processingSteps.find(s => s.status === 'In Progress')?.name?.toLowerCase();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 2, p: 0 } }}
        >
            <Box sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <img src="icons/done_icon.png" alt="Success" style={{ width: 20, height: 20, display: 'block' }} />
                        <Typography variant="h6" className={classes?.labelNoto16Bold500_hh}>Mark as Done</Typography>
                    </Box>
                    <IconButton onClick={onClose} size="small" disableRipple sx={{ color: '#666' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Typography variant="body1" className={classes?.labelNoto14Bold400_hh} sx={{ mb: 3, color: '#333', lineHeight: 1.5 }}>
                    Are you sure you want to mark {inProgressName} as done?
                </Typography>
                <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center' }}>
                    <Button onClick={onClose} variant="outlined" disableRipple className={classes?.whiteButton} sx={{ width: 126, minWidth: 126, height: 39, fontSize: '20.8px', borderRadius: '4px', borderWidth: '1px', opacity: 1, gap: '10px', p: '10px', border: '1px solid #000000' }}>Cancel</Button>
                    <Button onClick={onConfirm} variant="contained" disableRipple disabled={isActionInProgress} className={classes?.greenButton} sx={{ width: 126, minWidth: 126, height: 39, fontSize: '20.8px', borderRadius: '4px', opacity: 1, gap: '10px', p: '10px', background: '#058333' }}>Confirm</Button>
                </Box>
            </Box>
        </Dialog>
    );
}

export default ConfirmMarkDoneDialog;
